export interface FrameSample {
    label: string;
    durationMs: number;
    at: number;
}

export class FrameBudgetTracker {
    private samples: FrameSample[] = [];

    constructor(private readonly maxSamples: number = 120, private readonly budgetMs: number = 16) {}

    push(label: string, durationMs: number): void {
        this.samples.push({ label, durationMs, at: Date.now() });
        if (this.samples.length > this.maxSamples) {
            this.samples.splice(0, this.samples.length - this.maxSamples);
        }
    }

    getAverageMs(): number {
        if (this.samples.length === 0) return 0;
        const total = this.samples.reduce((sum, sample) => sum + sample.durationMs, 0);
        return total / this.samples.length;
    }

    getLatest(): FrameSample | null {
        if (this.samples.length === 0) return null;
        return this.samples[this.samples.length - 1];
    }

    isWithinBudget(durationMs: number): boolean {
        return durationMs <= this.budgetMs;
    }

    getBudgetMs(): number {
        return this.budgetMs;
    }
}

export function measureFrame(label: string, fn: () => void): FrameSample {
    const start = performance.now();
    fn();
    const end = performance.now();
    return {
        label,
        durationMs: end - start,
        at: Date.now(),
    };
}
